import type { Contact } from "app/pages/sales-intelligence/modules/ai-agent/types/meeting";
import { AttendeesSearch } from "./AttendeesSearch";
import { ContactCards } from "app/pages/sales-intelligence/pages/ai-agent/components/ContactCards/ContactCards";
import { useAttendeesValue } from "./useAttendeesValue";

type Props = {
    value: Contact[];
    onChange: (value: Contact[]) => void;
    disabled: boolean;
};

export const Attendees = ({ value, onChange, disabled }: Props) => {
    const {
        contacts,
        search,
        searchOptions,
        isLimitReached,
        isSearching,
        isSuggestionsLoading,
        hasNoSearchResults,
        hasSearchError,
        errorType,
        highlightedContactId,
        setSearch,
        handleCheckboxClick,
        handleOptionClick,
        handleAddNewContact,
        clearHighlight,
    } = useAttendeesValue({ value, onChange });

    return (
        <div>
            {disabled ? null : (
                <AttendeesSearch
                    search={search}
                    options={searchOptions}
                    isLimitReached={isLimitReached}
                    isSearching={isSearching}
                    hasNoResults={hasNoSearchResults}
                    hasError={hasSearchError}
                    errorType={errorType}
                    onSearchChange={setSearch}
                    onOptionClick={handleOptionClick}
                    onAddNew={handleAddNewContact}
                />
            )}
            <ContactCards
                onSelect={handleCheckboxClick}
                value={contacts}
                isDisabled={disabled}
                isLoading={isSuggestionsLoading}
                isLimitReached={isLimitReached}
                highlightedContactId={highlightedContactId}
                onHighlightEnd={clearHighlight}
            />
        </div>
    );
};
